module.exports = __webpack_public_path__ + "media/images/shopping-cart/oxxo-b30392627d33adb6c520d9f0fbc1949e.png";